import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Index from "./pages/Index";
import Assistant from "./pages/Assistant";
import Flights from "./pages/Flights";
import Itinerary from "./pages/Itinerary";
import Railways from "./pages/Railways";
import Weather from "./pages/Weather";
import NotFound from "./pages/NotFound";
import TravelPlanner from "./pages/TravelPlanner";

// Create a client
const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/assistant" element={<Assistant />} />
          <Route path="/flights" element={<Flights />} />
          <Route path="/itinerary" element={<Itinerary />} />
          <Route path="/railways" element={<Railways />} />
          <Route path="/weather" element={<Weather />} />
          <Route path="/planner" element={<TravelPlanner />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
